import { SortDirectionEnum } from "../services/Schemas/ListQueryString";

export interface ITableSchema {
  key: string;
  label: string;
  minWidth?: number;
  align?: "right" | "left" | "center";
  FilterComponent?: React.ElementType;
  sortable?: boolean;
  options?: IOptionTableSchema;
  format?: (value: string) => string;
  sortDirection?:SortDirectionEnum | null;
  visible?: boolean;
}

// filter schema in url
interface IFilter {
  column: string;
  operator: string;
  value: any;
}

export interface IFilters {
  [key: string]: IFilter;
}

export interface IOptionTableSchema{
  [key : string] : number | string;
}

export interface IOptionSchema {
  value: string;
  label: string;
};


// filter schema
export interface IFilterSchema {
  FilterComponent: React.ElementType;
  props: {
    columnName: string;
    label: string;
    value:any;
    operator:any;
  };
  options?: IOptionTableSchema;
}


export enum OperatorEnum {
  EQUAL = "equal",
  GREATER = "greater_than",
  LESS = "less_than",
  IS_EQUAL = "is_equal",
  IS_EQUAL_TO_OR_NULL = "is_equal_to_or_null",
  IS_NULL = "is_null",
  IS_NOT_EQUAL_TO = "is_not_equal_to",
  IS_NOT_NULL = "is_not_null",
  START_WITH = "start_with",
  DOES_NOT_CONTAINS = "does_not_contains",
  CONTAINS = "contains",
  ENDS_WITH = "ends_with",
  IN = "in",
  NOT_IN = "not_in",
  IN_OR_NULL = "in_or_null",
  BETWEEN = "between",
  IS_GREATER_THAN_OR_EQUAL_TO = "is_greater_than_or_equal_to",
  IS_GREATER_THAN_OR_NULL = "is_greater_than_or_null",
  IS_GREATER_THAN = "is_greater_than",
  IS_LESS_THAN_OR_EQUAL_TO = "is_less_than_or_equal_to",
  IS_LESS_THAN = "is_less_than",
  IS_LESS_THAN_OR_NULL = "is_less_than_or_null",
  IS_AFTER_THAN_OR_EQUAL_TO = "is_after_than_or_equal_to",
  IS_AFTER_THAN = "is_after_than",
  IS_BEFORE_THAN_OR_EQUAL_TO = "is_before_than_or_equal_to",
  IS_BEFORE_THAN = "is_before_than",
}
